const baseColors = {
  colorBase: '#2f3638',
  colorBlack: '#000',
  colorWhite: '#fff',
  colorGrey98: '#fafafa',
  colorGrey95: '#f0f2f2',
  colorGrey90: '#e3e7e8',
  colorGrey85: '#d9ddde',
  colorGrey80: '#cdd2d4',
  colorGrey60: '#959a9c',
  colorGrey40: '#5d6366',
  colorGrey20: '#2f3638',
  colorGrey10: '#171b1c',
};

const brandColors = {
  colorBrandPrimary: '#00aeef',
  colorBrandPrimary50: '#def4fd',
  colorBrandPrimary100: '#baeafc',
  colorBrandPrimary200: '#99dff9',
  colorBrandPrimary300: '#60cef7',
  colorBrandPrimary400: '#41beec',
  colorBrandPrimary500: '#00aeef',
  colorBrandPrimary600: '#219ddf',
  colorBrandPrimary700: '#1c8bc7',
  colorBrandPrimary800: '#187aad',
  colorBrandPrimary900: '#0f5a80',
  colorBrandSecondary: '#8dc63f',
  colorBrandSecondary50: '#f0f8f4',
  colorBrandSecondary100: '#dcecbd',
  colorBrandSecondary200: '#c7e395',
  colorBrandSecondary300: '#b1d767',
  colorBrandSecondary400: '#a0ce40',
  colorBrandSecondary500: '#8dc63f',
  colorBrandSecondary600: '#84b500',
  colorBrandSecondary700: '#75a106',
  colorBrandSecondary800: '#678d06',
  colorBrandSecondary900: '#4a6708',
  colorBrandOrange: '#ffc600',
  colorBrandRed: '#e60000',
};

const utilityColors = {
  colorLink: brandColors.colorBrandPrimary,
  colorLinkActive: brandColors.colorBrandPrimary700,
  colorBorder: baseColors.colorGrey80,
  colorInfoCopy: brandColors.colorBrandPrimary,
  colorInfoFill: brandColors.colorBrandPrimary50,
  colorInfoKeyline: '#b3e7fb',
  colorInfoCopyDark: '#b3e7fb',
  colorInfoFillDark: brandColors.colorBrandPrimary900,
  colorInfoKeylineDark: brandColors.colorBrandPrimary500,
  colorErrorCopy: brandColors.colorBrandRed,
  colorErrorFill: '#fbe5e5',
  colorErrorKeyline: '#f9bfbf',
  colorErrorCopyDark: '#f9bfbf',
  colorErrorFillDark: '#800000',
  colorErrorKeylineDark: brandColors.colorBrandRed,
  colorWarningCopy: '#f4b21e',
  colorWarningFill: '#fff1c0',
  colorWarningKeyline: '#ffe380',
  colorWarningCopyDark: '#ffe380',
  colorWarningFillDark: '#926607',
  colorWarningKeylineDark: '#f4b21e',
  colorSuccessCopy: '#7aaf2c',
  colorSuccessFill: '#eef7e2',
  colorSuccessKeyline: '#c0df95',
  colorSuccessCopyDark: '#c0df95',
  colorSuccessFillDark: brandColors.colorBrandSecondary900,
  colorSuccessKeylineDark: '#7aaf2c',
};

const socialColors = {
  colorTwitterCopy: baseColors.colorWhite,
  colorTwitterFill: '#55acee',
  colorFacebookCopy: baseColors.colorWhite,
  colorFacebookFill: '#3b5998',
  colorGoogleCopy: baseColors.colorWhite,
  colorGoogleFill: '#df4a32',
  colorLinkedinCopy: baseColors.colorWhite,
  colorLinkedinFill: '#1c87bd',
  colorYoutubeCopy: baseColors.colorWhite,
  colorYoutubeFill: '#cd201f',
  colorInstagramCopy: baseColors.colorWhite,
  colorInstagramFill: '#3f729b',
  colorFlickrCopy: baseColors.colorWhite,
  colorFlickrFill: '#1057ae',
  colorTumblrCopy: baseColors.colorWhite,
  colorTumblrFill: '#35465c',
  colorPinterestCopy: baseColors.colorWhite,
  colorPinterestFill: '#bd081c',
};

const gradients = {
  // Teal -> Blue
  gradientPrimary: `linear-gradient(135deg, #2cd5c4, ${
    brandColors.colorBrandPrimary
  })`,
  // Blue -> Teal
  gradientPrimaryInverse: `linear-gradient(135deg, ${
    brandColors.colorBrandPrimary
  }, #2cd5c4)`,
  // Purple -> Blue
  gradientSecondary: `linear-gradient(135deg, #7f4d8f, ${
    brandColors.colorBrandPrimary
  })`,
  // Green -> Teal
  gradientTertiary: `linear-gradient(120deg ,#8BC832, #2CD5C4)`,
};

export default {
  ...baseColors,
  ...brandColors,
  ...utilityColors,
  ...socialColors,
  ...gradients,
};
